module.exports = __webpack_public_path__ + "img/postgresql-client.61243489.svg";